type ArrayUpdateInPlace = <T>(array: T[], edge: T, compare: (a: T, b: T) => boolean) => T[];

export const arrayUpdateInPlace: ArrayUpdateInPlace = (array, edge, compare) => {
  const findIndex = array.findIndex((item) => compare(item, edge));

  if (findIndex < 0) {
    return [...array, edge];
  }

  return array.map((item) => {
    if (compare(item, edge)) {
      return edge;
    }

    return item;
  });
};
